/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetShiftReportRequest as AgentApiContractGetShiftReportRequest } from '../../models/AgentApi/Contract/get-shift-report-request';
import { GetShiftReportResponse as AgentApiContractGetShiftReportResponse } from '../../models/AgentApi/Contract/get-shift-report-response';

export interface ApiAgentGetShiftReportPost$Plain$Params {

/**
 * ui language code.
 */
  lang?: string;
      body?: AgentApiContractGetShiftReportRequest
}

export function apiAgentGetShiftReportPost$Plain(http: HttpClient, rootUrl: string, params?: ApiAgentGetShiftReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractGetShiftReportResponse>> {
  const rb = new RequestBuilder(rootUrl, apiAgentGetShiftReportPost$Plain.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractGetShiftReportResponse>;
    })
  );
}

apiAgentGetShiftReportPost$Plain.PATH = '/api/Agent/GetShiftReport';
